
import './loader.css';

import angular from 'angular';

import loaderService from '../../service/loader';
import loader from './loader';
import LoaderController from './loader.controller';

export default angular.module('directive.loader', [loaderService])
	.controller('LoaderController', LoaderController)
	.directive('loader', loader)
	.name;



// WEBPACK FOOTER //
// ./src/directive/loader/index.js